import React from 'react';
import { LucideIcon } from 'lucide-react';

interface FileUploadProps {
  label: string;
  accept: string;
  file: File | null;
  onFileChange: (file: File | null) => void;
  icon: React.ReactNode;
}

const FileUpload: React.FC<FileUploadProps> = ({ label, accept, file, onFileChange, icon }) => {
  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const selectedFile = e.target.files?.[0] || null;
    onFileChange(selectedFile);
  };

  return (
    <div className="space-y-2">
      <label className="block text-sm font-medium text-gray-700">{label}</label>
      <div className="relative">
        <input
          type="file"
          accept={accept}
          onChange={handleFileChange}
          className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
        />
        <div className={`flex items-center space-x-3 p-3 border-2 border-dashed rounded-lg transition-colors ${
          file ? 'border-green-500 bg-green-50' : 'border-gray-300 hover:border-gray-400'
        }`}>
          <div className={`flex-shrink-0 ${file ? 'text-green-600' : 'text-gray-400'}`}>
            {icon}
          </div>
          <div className="flex-1 min-w-0">
            <p className="text-sm font-medium text-gray-900 truncate">
              {file ? file.name : `Choose ${label.toLowerCase()}`}
            </p>
            <p className="text-xs text-gray-500">
              {file ? `${(file.size / 1024 / 1024).toFixed(2)} MB` : 'Click to browse'}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FileUpload;
